import React, { useContext, useEffect } from "react";
import { NavContext } from "../../state/NavContext";
import GameList from "./components/GameList";
import MovieList from "./components/MovieList";

const Home = () => {
  const { setActiveIndex, setIsSideBarActive } = useContext(NavContext);

  useEffect(() => {
    setActiveIndex("home");
    setIsSideBarActive(false);
  }, [setActiveIndex, setIsSideBarActive]);

  return (
    <div>
      <MovieList maxItem={4} />
      <GameList maxItem={4} />
    </div>
  );
};

export default Home;
